import React from "react";
import ApiServices from "../../../Utils/ApiServices/ApiServices";
import RiteDepartmentForm from "./RiteDepartmentForm";
import { getDecryptedAccessToken } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";

const RiteDepartmentAdd = ({ onCreated }) => {

  const handleSubmit = async (data) => {

    try {

      const token = getDecryptedAccessToken();

      await ApiServices.post(
        "/api/v1/admin/departments/",
        data,
        { Authorization: `Bearer ${token}` }
      );

      onCreated();

    } catch (error) {
      console.error("Error creating department:", error);
    }

  };

  return (
    <RiteDepartmentForm
      title="Create Department"
      onSubmit={handleSubmit}
    />
  );
};

export default RiteDepartmentAdd;